import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	CurrencyAmountPipe,
	DollarShorthandPipe,
} from '@marmon/frontend/common';
import { TuiHint } from '@taiga-ui/core';
import { AnalysisCardComponent } from '../analysis-card/analysis-card.component';
import { DistributionBoxComponent } from '../box-distribution-card/distribution-box/distribution-box.component';
import {
	AnalysisColorCode,
	BoxDistributionCardBaseComponent,
} from './box-distribution-card-base.component';

@Component({
	standalone: true,
	imports: [
		AnalysisCardComponent,
		TuiHint,
		TranslocoPipe,
		CurrencyAmountPipe,
		DistributionBoxComponent,
		DollarShorthandPipe,
	],
	selector: 'mar-rot-box-distribution-card',
	templateUrl: 'box-distribution-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'contents' },
})
export class RotBoxDistributionCardComponent extends BoxDistributionCardBaseComponent {
	override readonly targets = () =>
		({ 0: 0.89, 1: 0.07, 2: 0.03, 3: 0.01 }) as const;

	/**
	 * No colors are needed for "Rule of Thumb" calculations.
	 */
	override getColorCode(): AnalysisColorCode {
		return 'gray';
	}
}
